<template>
  <el-container class="main-container">
    <el-header>
      <el-menu
        :default-active="$route.path"
        v-if="windowWidth >= 720"
        class="el-menu-demo"
        background-color="#001d3d"
        text-color="#fff"
        active-text-color="#fff"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-button
          class="menu-button"
          @click="submenuTrigger"
          type="text"
          :icon="CollapseIcon"
          v-if="windowWidth >= 720"
        ></el-button>
        <el-submenu 
          style="float: right" 
          index="8" 
          class="user-info-menu"
          popper-class="user-info-dropdown">
          <template slot="title">
            <div class="user-info-wrapper">
              <user-avatar
                class="header-user-avatar"
                :name="name"
                :username="username"
                :avatar="avatar"
                :user-id="username"
                size="md"
              />
              <div class="user-details">
                <div class="user-name">{{ name || '用户' }}</div>
                <div class="user-role">{{ role }}</div>
              </div>
            </div>
          </template>
          <el-menu-item
            class="logout-menu-item"
            index="8-1"
            @click="loginOutHander"
            ><i class="el-icon-switch-button" />退出登录</el-menu-item
          >
        </el-submenu>
      <span class="logo-text">宇捷管理系统</span>
      
      </el-menu>
      <el-menu
        :default-active="$route.path"
        v-if="windowWidth < 720"
        class="el-menu-demo"
        background-color="#001d3d"
        text-color="#fff"
        active-text-color="#fff"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-button
          title="移动端标题栏"
          class="menu-button"
          @click="submenuTrigger"
          type="text"
          :icon="CollapseIcon"
        ></el-button>
        <el-submenu 
          style="float: right" 
          index="8" 
          class="user-info-menu"
          popper-class="user-info-dropdown">
          <template slot="title">
            <div class="user-info-wrapper">
              <user-avatar
                class="header-user-avatar"
                :name="name"
                :username="username"
                :avatar="avatar"
                :user-id="username"
                size="md"
              />
              <div class="user-details">
                <div class="user-name">{{ name || '用户' }}</div>
                <div class="user-role">{{ role }}</div>
              </div>
            </div>
          </template>
          <el-menu-item
            class="logout-menu-item"
            index="8-1"
            @click="loginOutHander"
            ><i class="el-icon-switch-button" />退出登录</el-menu-item
          >
        </el-submenu>
        <span class="logo-text">宇捷管理系统</span>
      </el-menu>
    </el-header>
    <el-container>
      <el-aside width="auto" v-if="windowWidth >= 720">
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo left-menu"
          @open="handleOpen"
          @close="handleClose"
          :collapse="isCollapse"
          :router="true"
        >
          <el-menu-item index="/yj/home">
            <i class="el-icon-house"></i>
            <span slot="title" class="menu-title">系统主页</span>
          </el-menu-item>
          <template v-if="roleId === 3">
            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title" class="menu-title">课程学习</span>
              </template>
              <el-menu-item index="/yj/video">在线学习</el-menu-item>
              <el-menu-item index="/yj/upload">提交作业</el-menu-item>
              <el-menu-item index="/yj/mine">作业记录</el-menu-item>
            </el-submenu>
          </template>
          <template v-if="roleId !== 3">
            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title" class="menu-title">合同资源管理</span>
              </template>
              <!-- <el-menu-item index="/yj/subject">新增课程章节</el-menu-item> -->
              <!-- <el-menu-item index="/yj/source">上传课程资源</el-menu-item> -->
              <el-menu-item index="/yj/workform">合同上传</el-menu-item>
              <el-menu-item index="/yj/import-hetong">合同批量上传</el-menu-item>
              <el-menu-item index="/yj/manage-sub">承接单位管理</el-menu-item>
              <el-menu-item index="/yj/manage-service-content">服务内容管理</el-menu-item>
              <!-- <el-menu-item index="/yj/manage-source">资源管理</el-menu-item> -->
              <el-menu-item index="/yj/work">合同管理</el-menu-item>
              <el-menu-item index="/yj/contract/my-apply" v-if="roleId !== 1">我的申请</el-menu-item>
              <el-menu-item index="/yj/contract/approval" v-if="roleId === 1">合同审批管理</el-menu-item>
              <!-- <el-menu-item index="/yj/manage-source">资源管理</el-menu-item> -->
              <!-- <el-menu-item index="/yj/review">批阅学生作业</el-menu-item>
              <el-menu-item index="/yj/query-stu">管理学生作业</el-menu-item> -->
            </el-submenu>
          </template>
          <template v-if="roleId == 1">
            <el-submenu index="4">
              <template slot="title">
                <i class="el-icon-user"></i>
                <span slot="title" class="menu-title">员工管理</span>
              </template>
              <!-- <el-menu-item index="/yj/manage-stu">学生管理</el-menu-item> -->
              <el-menu-item index="/yj/manage-tea" v-if="roleId === 1"
                >员工管理</el-menu-item
              >
              <el-menu-item index="/yj/import-tea">员工导入</el-menu-item>
              <!-- <el-menu-item index="/yj/manage-class" v-if="roleId === 1"
                >班级管理</el-menu-item
              >
              <el-menu-item index="/yj/query-sign">考勤管理</el-menu-item> -->
            </el-submenu>
            <!-- <el-submenu index="5">
              <template slot="title">
                <i class="el-icon-receiving"></i>
                <span slot="title" class="menu-title">数据管理</span>
              </template>
              <el-menu-item index="/yj/manage-sub">承接单位管理</el-menu-item>
              
              <el-menu-item index="/yj/work">合同管理</el-menu-item>
            </el-submenu> -->
          </template>
          <!-- <template v-if="roleId == 1">
            <el-submenu index="6">
              <template slot="title">
                <i class="el-icon-upload"></i>
                <span slot="title" class="menu-title">数据导入</span>
              </template>
              <el-menu-item index="/yj/import-tea">员工导入</el-menu-item>
            </el-submenu>
          </template> -->
          <el-submenu index="7">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span slot="title" class="menu-title">系统设置</span>
            </template>
            <el-menu-item index="/yj/password">个人设置</el-menu-item>
          </el-submenu>
        </el-menu></el-aside
      >
      <el-container style="height: auto">
        <el-main>
          <el-drawer
            title="移动端菜单栏"
            :visible.sync="isCollapse"
            :with-header="false"
            direction="ltr"
            size="50%"
            v-if="windowWidth < 720"
          >
            <el-menu
              :default-active="$route.path"
              class="left-menu"
              @select="mobileMenuSelect"
              @open="handleOpen"
              @close="handleClose"
              :collapse="false"
              :router="true"
              :unique-opened="true"
            >
              <el-menu-item index="/yj/home">
                <i class="el-icon-house"></i>
                <span slot="title" class="menu-title">系统主页</span>
              </el-menu-item>
              <template v-if="roleId === 3">
                <el-submenu index="2">
                  <template slot="title">
                    <i class="el-icon-menu"></i>
                    <span slot="title" class="menu-title">课程学习</span>
                  </template>
                  <el-menu-item index="/yj/video">在线学习</el-menu-item>
                  <el-menu-item index="/yj/upload">提交作业</el-menu-item>
                  <el-menu-item index="/yj/mine">作业记录</el-menu-item>
                </el-submenu>
              </template>
              <template v-if="roleId !== 3">
                <el-submenu index="3">
                  <template slot="title">
                    <i class="el-icon-menu"></i>
                    <span slot="title" class="menu-title">合同资源管理</span>
                  </template>
                  <!-- <el-menu-item index="/yj/subject">新增课程章节</el-menu-item>  -->
                  <!-- <el-menu-item index="/yj/source">上传课程资源</el-menu-item> -->
                  <el-menu-item index="/yj/workform"
                    >合同上传</el-menu-item
                  >
                  <el-menu-item index="/yj/import-hetong">合同批量上传</el-menu-item>
                  <el-menu-item index="/yj/manage-sub">承接单位管理</el-menu-item>
                  <el-menu-item index="/yj/manage-service-content">服务内容管理</el-menu-item>
                  <el-menu-item index="/yj/work">合同管理</el-menu-item>
                  <el-menu-item index="/yj/contract/my-apply" v-if="roleId !== 1">我的申请</el-menu-item>
                  <el-menu-item index="/yj/contract/approval" v-if="roleId === 1">合同审批管理</el-menu-item>
                  <!-- <el-menu-item index="/yj/manage-source"
                    >资源管理</el-menu-item
                  > -->
                  <!-- <el-menu-item index="/yj/review">批阅学生作业</el-menu-item>
                  <el-menu-item index="/yj/query-stu"
                    >管理学生作业</el-menu-item
                  > -->
                </el-submenu>
              </template>
              <template v-if="roleId == 1">
                <el-submenu index="4">
                  <template slot="title">
                    <i class="el-icon-user"></i>
                    <span slot="title" class="menu-title">员工管理</span>
                  </template>
                  <!-- <el-menu-item index="/yj/manage-stu">学生管理</el-menu-item> -->
                  <el-menu-item index="/yj/manage-tea" v-if="roleId === 1"
                    >员工管理</el-menu-item
                  >
                  <el-menu-item index="/yj/import-tea">员工导入</el-menu-item>
                  <!-- <el-menu-item index="/yj/manage-class" v-if="roleId === 1"
                    >班级管理</el-menu-item
                  >
                  <el-menu-item index="/yj/query-sign">考勤管理</el-menu-item> -->
                </el-submenu>
                <!-- <el-submenu index="5">
                  <template slot="title">
                    <i class="el-icon-receiving"></i>
                    <span slot="title" class="menu-title">数据管理</span>
                  </template>
                  <el-menu-item index="/yj/manage-sub">承接单位管理</el-menu-item>

                  <el-menu-item index="/yj/work">合同管理</el-menu-item>
                </el-submenu> -->
              </template>
              <!-- <template v-if="roleId == 1">
                <el-submenu index="6">
                  <template slot="title">
                    <i class="el-icon-upload"></i>
                    <span slot="title" class="menu-title">数据导入</span>
                  </template>
                  <el-menu-item index="/yj/import-tea">员工导入</el-menu-item>
                </el-submenu>
              </template> -->
              <el-submenu index="7">
                <template slot="title">
                  <i class="el-icon-setting"></i>
                  <span slot="title" class="menu-title">系统设置</span>
                </template>
                <el-menu-item index="/yj/password">个人设置</el-menu-item>
              </el-submenu>
            </el-menu>
          </el-drawer>
          <router-view
        /></el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
// @ is an alias to /src
import { initHome, logout } from "../api";
import { mapGetters } from "vuex";
import UserAvatar from "../components/UserAvatar.vue";
export default {
  name: "HomeScreen",
  components: { UserAvatar },
  data() {
    return {
      isCollapse: false,
      CollapseIcon: "el-icon-s-fold",
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
    };
  },
  watch: {
    windowWidth(val) {
      let that = this;
      //closeDebug console.log("实时屏幕宽度：", val, that.windowHeight);
    },
  },

  computed: {
    ...mapGetters([
      "name", //用户名
      "username",
      "role",
      "roleId",
      "genderId",
      "avatar",
      //如果是学生的话还有以下参数
      "grade",
      "major",
      "college",
      "l_class",
    ]),
  },
  mounted() {
    //进入时进行用户信息初始化
    this.init();
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth;
        that.windowWidth = window.fullWidth; // 宽
      })();
    };
    if (document.documentElement.clientWidth < 720) {
      //closeDebug console.log("触发移动端布局");
      this.CollapseIcon = "el-icon-s-unfold";
    }
  },
  methods: {
    //初始化角色
    init() {
      let _this = this;
      initHome()
        .then((res) => {
          //closeDebug console.log("-----------主页初始化---------------");
          if (res.code === 0) {
            // _this.$notify({
            //   title: "登陆成功",
            //   message: "欢迎回来",
            //   type: 'success'
            // });
            let obj = JSON.parse(res.msg);
            //closeDebug console.log("用户信息解析", obj);
            this.$store.commit("initUserInfo", {
              roleId: obj.l_roleId, //角色
              name: obj.l_name, //用户姓名
              reviewer: obj.l_name, //审阅人姓名
              username: obj.l_username, //用户编号
              role: obj.l_role, //用户角色
              genderId: obj.l_genderId, //性别
              avatar: obj.l_avatar || "",
              //如果是学生的话还有以下参数
              grade: obj.l_grade, //年级
              major: obj.l_major, //专业
              l_genderId: obj.l_genderId, //性别
              l_class: obj.l_class, //班级
            });
          } else {
            _this.$notify({
              title: "未能读取到个人信息",
              message: "请重新登陆",
              type: "warning",
            });
            _this.$router.push({ path: "/" });
          }
        })
        .catch((failResponse) => {});
    },
    submenuTrigger() {
      this.isCollapse = !this.isCollapse;
      this.CollapseIcon = this.isCollapse
        ? "el-icon-s-unfold"
        : "el-icon-s-fold";
    },
    handleOpen(key, keyPath) {
      //closeDebug console.log("侧边菜单打开了", key, keyPath);
    },
    handleClose(key, keyPath) {
      //closeDebug console.log("侧边菜单关闭了", key, keyPath);
    },
    handleSelect(key, keyPath) {
      //closeDebug console.log("顶部菜单选中了", key, keyPath);
    },
    mobileMenuSelect(key, keyPath) {
      this.isCollapse = false;
    },
    loginExam() {
      let _this = this;
      this.$confirm(
        "即将进入考试模式，宇捷管理系统登陆状态将会失效。是否确认?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        logout()
          .then((res) => {
            //closeDebug console.log("退出登陆", res);
            if (res.code === 0) {
              _this.$message({
                showClose: true,
                message: res.msg,
                type: "success",
              });
              //设置登陆状态
              // _this.$store.commit("setLoginState", false);
            } else {
              _this.$message({
                showClose: true,
                message: res.msg,
                type: "error",
              });
            }
          })
          .catch((failResponse) => {});
        setTimeout(function () {
          //跳转到百度
          window.location.href = "http://exam.844307947.xyz/";
        }, 1000);
      });
    },
    loginOutHander() {
      let _this = this;
      logout()
        .then((res) => {
          //closeDebug console.log("退出登陆", res);
          if (res.code === 0) {
            _this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            //设置登陆状态
            // _this.$store.commit("setLoginState", false);
          } else {
            _this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
            });
            _this.changeCode();
          }
        })
        .catch((failResponse) => {});
      setTimeout(function () {
        _this.$router.push({ path: "/" });
      }, 1000);
    },
  },
};
</script>
<style>
/* 主容器 */
.main-container {
  height: 100%;
  background: #f5f7fa;
}

/* Logo样式 */
.logo {
  float: left;
  font-weight: 800;
  font-size: 36px;
  color: #9b9b9bbe;
}

.logo-text {
  margin-left: 16px;
  float: left;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.logo-text:hover {
  color: #409eff;
  transform: scale(1.05);
}

/* 头部导航栏 */
.el-header {
  background: linear-gradient(135deg, #001d3d 0%, #003d7a 100%);
  color: #333;
  text-align: center;
  line-height: 60px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1000;
  padding: 0 20px;
}

.el-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(64, 158, 255, 0.5), transparent);
}

/* 顶部菜单 */
.el-menu-demo {
  background-color: transparent !important;
  border-bottom: none !important;
}

.el-menu-demo .el-menu-item,
.el-menu-demo .el-submenu__title {
  color: rgba(255, 255, 255, 0.9) !important;
  transition: all 0.3s ease;
}

.el-menu-demo .el-menu-item:hover,
.el-menu-demo .el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff !important;
}

.el-menu-demo .el-submenu.is-opened > .el-submenu__title {
  color: #ffffff !important;
}

/* 确保用户信息菜单不受默认样式影响 */
.el-menu-demo .user-info-menu .el-submenu__title {
  background: transparent !important;
}

.el-menu-demo .user-info-menu .el-submenu__title:hover {
  background: transparent !important;
}

/* 退出登录菜单 - 与上方风格一致 */
.user-info-dropdown {
  background: rgba(0, 29, 61, 0.95) !important;
  backdrop-filter: blur(12px) !important;
  border-radius: 10px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;
  padding: 6px !important;
  max-width: 100% !important;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
}

.user-info-dropdown .el-menu {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  width: 100% !important;
}

.user-info-dropdown .el-menu-item {
  color: rgba(255, 255, 255, 0.9) !important;
  transition: all 0.3s ease !important;
  margin: 0 !important;
  border-radius: 6px !important;
  height: 44px !important;
  line-height: 44px !important;
  padding: 0 18px !important;
  font-size: 15px !important;
  text-align: center !important;
  background: transparent !important;
  font-weight: 500 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.user-info-dropdown .el-menu-item:hover {
  background: rgba(245, 108, 108, 0.25) !important;
  color: #ffffff !important;
  transform: none !important;
  box-shadow: none !important;
}

.user-info-dropdown .el-menu-item i {
  margin-right: 8px !important;
  font-size: 18px !important;
  color: #f56c6c !important;
  width: 20px !important;
  text-align: center !important;
  font-weight: bold !important;
}

/* 针对用户信息菜单的下拉菜单 */
.el-menu-demo .user-info-menu .el-menu.el-menu--popup {
  background: rgba(0, 29, 61, 0.98) !important;
  backdrop-filter: blur(12px) !important;
  border-radius: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;
  padding: 6px 0 !important;
  margin-top: 8px !important;
  min-width: 140px !important;
}

.el-menu-demo .user-info-menu .el-menu.el-menu--popup .el-menu-item,
.el-menu-demo .user-info-menu .el-menu.el-menu--popup .logout-menu-item {
  color: rgba(255, 255, 255, 0.9) !important;
  transition: all 0.3s ease !important;
  margin: 2px 6px !important;
  border-radius: 6px !important;
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 16px !important;
  font-size: 14px !important;
  text-align: center !important;
  background: transparent !important;
}

.el-menu-demo .user-info-menu .el-menu.el-menu--popup .el-menu-item:hover,
.el-menu-demo .user-info-menu .el-menu.el-menu--popup .logout-menu-item:hover {
  background: rgba(64, 158, 255, 0.25) !important;
  color: #ffffff !important;
  transform: translateX(2px);
}

.el-menu-demo .user-info-menu .el-menu.el-menu--popup .el-menu-item i,
.el-menu-demo .user-info-menu .el-menu.el-menu--popup .logout-menu-item i {
  margin-right: 10px !important;
  font-size: 16px !important;
  color: #f56c6c !important;
}

/* 侧边栏 */
.el-aside {
  background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
  color: rgb(71, 71, 71);
  text-align: left;
  line-height: 300px;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 8px 0 rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.el-menu-vertical-demo {
  border-right: none;
  background-color: transparent;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 220px;
  border-right: 0;
}

.el-menu-vertical-demo .el-menu-item,
.el-menu-vertical-demo .el-submenu__title {
  height: 48px;
  line-height: 48px;
  margin: 4px 12px;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: #606266;
  font-weight: 500;
}

.el-menu-vertical-demo .el-menu-item:hover,
.el-menu-vertical-demo .el-submenu__title:hover {
  background-color: rgba(64, 158, 255, 0.1);
  color: #409eff;
  transform: translateX(4px);
}

.el-menu-vertical-demo .el-menu-item.is-active {
  background: linear-gradient(90deg, rgba(64, 158, 255, 0.15) 0%, rgba(64, 158, 255, 0.05) 100%);
  color: #409eff;
  font-weight: 600;
  border-left: 3px solid #409eff;
}

.el-menu-vertical-demo .el-menu-item i,
.el-menu-vertical-demo .el-submenu__title i {
  margin-right: 12px;
  font-size: 18px;
  width: 20px;
  text-align: center;
}

/* 菜单标题 */
.menu-title {
  font-weight: 500;
  font-size: 14px;
}

/* 菜单按钮 */
.menu-button {
  float: left !important;
  color: rgba(255, 255, 255, 0.9) !important;
  margin: 15px 12px 0px 0px !important;
  padding: 0px !important;
  font-size: 24px !important;
  transition: all 0.3s ease;
  background: transparent !important;
  border: none !important;
}

.menu-button:hover {
  color: #ffffff !important;
  transform: scale(1.1) rotate(90deg);
}

/* 主内容区 */
.el-main {
  background: linear-gradient(to bottom, #f5f7fa 0%, #fafaff 100%);
  color: #333;
  padding: 24px;
  min-height: calc(100vh - 60px);
  position: relative;
}

/* 移动端抽屉 */
.el-drawer {
  background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
}

.el-drawer .left-menu {
  border-right: none;
  background-color: transparent;
}

.el-drawer .left-menu .el-menu-item,
.el-drawer .left-menu .el-submenu__title {
  height: 48px;
  line-height: 48px;
  margin: 4px 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.el-drawer .left-menu .el-menu-item:hover,
.el-drawer .left-menu .el-submenu__title:hover {
  background-color: rgba(64, 158, 255, 0.1);
  color: #409eff;
}

.el-drawer .left-menu .el-menu-item.is-active {
  background: linear-gradient(90deg, rgba(64, 158, 255, 0.15) 0%, rgba(64, 158, 255, 0.05) 100%);
  color: #409eff;
  font-weight: 600;
  border-left: 3px solid #409eff;
}

/* 链接样式 */
.bottom-link {
  text-decoration: none;
  transition: color 0.3s ease;
}

.bottom-link:link {
  color: #409eff;
}

.bottom-link:visited {
  color: #67c23a;
}

.bottom-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}

/* 响应式优化 */
@media (max-width: 768px) {
  .el-header {
    padding: 0 12px;
  }

  .logo-text {
    font-size: 18px;
    margin-left: 12px;
  }

  .el-main {
    padding: 16px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
  }
}

/* 动画效果 */
@keyframes slideInLeft {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.el-menu-vertical-demo .el-menu-item,
.el-menu-vertical-demo .el-submenu__title {
  animation: slideInLeft 0.3s ease forwards;
}

/* 滚动条美化（侧边栏） */
.el-aside .el-menu {
  overflow-y: auto;
  overflow-x: hidden;
}

.el-aside .el-menu::-webkit-scrollbar {
  width: 6px;
}

.el-aside .el-menu::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.el-aside .el-menu::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 用户信息菜单 - 全新设计 */
.user-info-menu {
  margin-right: 12px;
}

.user-info-menu .el-submenu__title {
  padding: 0 !important;
  height: auto !important;
  line-height: normal !important;
  background: transparent !important;
  border: none !important;
}

.user-info-menu .el-submenu__title:hover {
  background: transparent !important;
}

.user-info-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 24px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.user-info-wrapper:hover {
  background: rgba(255, 255, 255, 0.22);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  border-color: rgba(255, 255, 255, 0.3);
}

.header-user-avatar {
  width: 38px !important;
  height: 38px !important;
  font-size: 15px !important;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25);
  border: 2px solid rgba(255, 255, 255, 0.35);
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

.user-info-wrapper:hover .header-user-avatar {
  transform: scale(1.05);
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1;
}

.user-name {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 0.2px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.user-role {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  background: rgba(64, 158, 255, 0.2);
  padding: 3px 10px;
  border-radius: 8px;
  font-weight: 500;
  white-space: nowrap;
  display: inline-block;
  width: fit-content;
  line-height: 1.5;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* 下拉菜单样式优化 */
.user-info-menu .el-menu {
  background: rgba(0, 29, 61, 0.98) !important;
  backdrop-filter: blur(12px);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  padding: 6px 0;
  margin-top: 8px;
  min-width: 140px;
}

.user-info-menu .el-menu-item,
.user-info-menu .logout-menu-item {
  color: rgba(255, 255, 255, 0.9) !important;
  transition: all 0.3s ease !important;
  margin: 2px 6px !important;
  border-radius: 6px !important;
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 16px !important;
  font-size: 14px !important;
  text-align: center !important;
  background: transparent !important;
}

.user-info-menu .el-menu-item:hover,
.user-info-menu .logout-menu-item:hover {
  background: rgba(64, 158, 255, 0.25) !important;
  color: #ffffff !important;
  transform: translateX(2px);
}

.user-info-menu .el-menu-item i,
.user-info-menu .logout-menu-item i {
  margin-right: 10px !important;
  font-size: 16px !important;
  color: #f56c6c !important;
}

/* 确保退出登录菜单项样式生效 */
.el-menu-demo .user-info-menu .el-menu-item,
.el-menu-demo .user-info-menu .logout-menu-item {
  color: rgba(255, 255, 255, 0.9) !important;
  background: transparent !important;
}

.el-menu-demo .user-info-menu .el-menu-item:hover,
.el-menu-demo .user-info-menu .logout-menu-item:hover {
  background: rgba(64, 158, 255, 0.25) !important;
  color: #ffffff !important;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .user-info-wrapper {
    gap: 10px;
    padding: 6px 18px;
  }
  
  .header-user-avatar {
    width: 32px !important;
    height: 32px !important;
    font-size: 13px !important;
  }
  
  .user-name {
    font-size: 14px;
  }
  
  .user-role {
    font-size: 11px;
    padding: 2px 8px;
  }
}
</style>
